import store from './store'
import router from './router'
import {StateChanges} from './store/stateChanges'
import {LATEST_VERSION, createSubset, StateSaver} from './js/localData'
import {StatePartTypes} from './store/stateParts'

const documentStatePartTypes = Object.keys(StatePartTypes).filter(statePartType => statePartType.includes('document'))
// there SHOULD be exactly ONE, but just in case...
const documentStatePartType = documentStatePartTypes.length ? documentStatePartTypes[0] : 'DOCUMENT'
const SavedStateName = 'abbreviation-expander-saved-state'

function load(savedStateString, {justTrying = false} = {}) {
  let savedStatePart
  let stateToCommit = {}
  let parseError = null
  let validationResult
  try {
    savedStatePart = JSON.parse(savedStateString)
  } catch (error) {
    parseError = error
  }
  if (parseError || typeof savedStatePart !== 'object' || savedStatePart === null) {
    validationResult = {
      summary: 'failure', success: false, savedStateString: savedStateString, failures: [{
        failureType: 'invalid ' + SavedStateName + '-' + documentStatePartType,
        errorData: parseError ? 'JSON parse error' : 'not an \'object\''
      }]
    }
  }
  if (!validationResult && !(StatePartTypes[documentStatePartType].every(key => savedStatePart[key] !== undefined))) {
    validationResult = {
      summary: 'failure', success: false, savedStateString: savedStateString, failures: [{
        failureType: 'invalid ' + SavedStateName + '-' + documentStatePartType,
        errorData: 'does not contain all expected properties'
      }]
    }
  }
  if (validationResult) {
    // eslint-disable-next-line no-console
    if (!justTrying) console.log('Document loading validation results: ' + JSON.stringify(validationResult))
  } else {
    Object.assign(stateToCommit, createSubset(savedStatePart, ...(StatePartTypes[documentStatePartType])))
    store.commit(StateChanges.BUILD_STATE, {
      contextData: { wordIndex: 0, letterIndex: 0 }, // for undo
      newStateJson: JSON.stringify(stateToCommit),
      calledBy: 'DocumentManager'
    })
    if (router.currentRoute.name !== 'nikud-edit') {
      if (router.currentRoute.name !== 'text-prep') router.push({
        name: stateToCommit.allWorkingNikud.wordsArray.length ? 'nikud-edit' : 'text-prep'})
    }
  }
  return validationResult
}

function save() {
  const statePartToSave = createSubset(store.state, ...(StatePartTypes[documentStatePartType]))
  Object.assign(statePartToSave, { version: LATEST_VERSION })
  return JSON.stringify(statePartToSave)
}

function importText (mainText) {
  const JUST_TRYING = true
  if (!load(mainText, {justTrying: JUST_TRYING}).success) { // i.e. the "mainText" is NOT json
    store.commit(StateChanges.EDIT_DOCUMENT_TEXT, {text: mainText, nullifySource: true})
    StateSaver.saveState(store.state)
    router.push({
      name: 'text-prep',
      params: { lockText: true }
    })
  }
}

function exportText () {
  return {
    extension: 'json',
    file: save()
  }
}

export const DocumentManager = {
  load, save, importText, exportText
}
